import { bindStateTabs } from "../consts/stateTabs";

//! @ngInject
export function savedReportsCtrl(
    $scope,
    $state
) {
    // In the order saved-reports.html renders them, and the destinations the AI omnibar offers
    // for this page - see the `tabs` beside it in config.js.
    const tabs = bindStateTabs($scope, $state, [
        "app.reports.savedReports.my",
        "app.reports.savedReports.shared"
    ]);

    $scope.goToReportState = tabs.goToState;
};
